import {Component, OnInit} from '@angular/core';
import {UsuarioService} from '../../services/usuario/usuario.service';
import {Usuario} from '../../../models/usuario.interface';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent implements OnInit {

  usuarioB: Usuario;

  versao = '';

  constructor(
    private readonly usuarioService: UsuarioService
  ) {
    this.usuarioB = JSON.parse(window.localStorage.getItem('usuario'));
  }

  ngOnInit(): void {
    this.usuarioService.pegarVersion().subscribe({
      next: version => {
        this.versao = version.versao;
      }
    });
  }

}
